import { render, staticRenderFns } from "./orderDetail.vue?vue&type=template&id=5763bdbc&scoped=true&"
import script from "./orderDetail.vue?vue&type=script&lang=js&"
export * from "./orderDetail.vue?vue&type=script&lang=js&"
import style0 from "./orderDetail.vue?vue&type=style&index=0&id=5763bdbc&prod&scoped=true&lang=scss&"
import style1 from "./orderDetail.vue?vue&type=style&index=1&id=5763bdbc&prod&lang=css&"
import style2 from "./orderDetail.vue?vue&type=style&index=2&id=5763bdbc&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5763bdbc",
  null
  
)

export default component.exports